var exports = {
  "i": "xa15a2ab7--ca509f--wrapper",
};

module.exports = exports;
